import {
  getItemfromStorage,
  setItemToStorage,
} from '../platform-components/utils/common-utils';
let questionIds = [];
export const setQuestionIds = (val) => {
  console.log('val: ', val);
  setItemToStorage('questionIds', val);
  questionIds = val;
};
export const getQuestionIds = (val) => {
  if (questionIds?.length > 0) {
    return questionIds;
  }
  let ids = getItemfromStorage('questionIds');
  return ids instanceof Array ? ids : [];
};
